import { t } from "@lingui/macro";
import React from "react";

import { BlockCard } from "@whoosh/design-system/src/apps/PatronApp/components/BlockCard/BlockCard";

export const UnavailableSlot = ({
  durationMins,
  startTime,
}: {
  durationMins: number;
  startTime?: string | null;
}) => {
  return (
    <BlockCard
      durationMins={durationMins}
      colorVariant="Gray"
      title={t`Unavailable`}
    />
  );
};
